// @flow
import { useEffect } from "react";
import { isUndefined } from "lodash";
import startOfToday from "date-fns/startOfToday";
import { asAbsolute } from "root/routes/utils";


export const clearTabSelectionOnNewBatch = (props: Object, prevProps: Object, clearAction: Function) => {
	const batchStartCounter = !isUndefined(props.batchStartCounter)
		? props.batchStartCounter
		: props.tabData.batchStartCounter;

	const prevBatchStartCounter = !isUndefined(prevProps.batchStartCounter)
		? prevProps.batchStartCounter
		: prevProps.tabData.batchStartCounter;

	if (props.contextData.selected
        && props.contextData.selected.length
        && batchStartCounter > prevBatchStartCounter) {
		clearAction();
	}
};

/**
 * call clearAction on unmounting of your component
 * @param clearAction - should be constant between your component's re-render !
 */
export const useClearTabSelectionOnUnmount = (clearAction: () => void) => {
	useEffect(() =>
	// will only be called during unmount
		() => {
			clearAction();
		},
	[clearAction]);
};

export const getInternalPath = (source: string, page?: string) => {
	return page ? asAbsolute(source, page) : asAbsolute(source);
};

export const getSelectedItemByValue = (value: string | string[], options: { label: string, value: string }, isMulti = false): Object => {
	return isMulti ? options.filter((item) => value.includes(item.value)) : options.find((item) => item.value === value);
};

export const secondsToMinutes = (sec) => {
	return `${new Date(sec * 1000).toISOString().substr(14, 5)}${sec === 120 ? "+" : ""}`;
};

export const today = () => startOfToday();

